const handleAnswerOpening = () => {
  const faqItems = document.querySelectorAll(".faq-item");

  window.dataLayer = window.dataLayer || [];

  faqItems.forEach((item, index) => {
    const question = item.querySelector(".question");
    const answer = item.querySelector(".faq-item p");
    const button = item.querySelector(".question button");

    question.addEventListener("click", () => {
      if (!button.classList.contains("rotate")) {
        window.dataLayer.push({
          event: "open_accordion",
          id: `Accordion_FaqClimatempo_Item_Questao-0${index + 1}`,
          name: "Accordion_FaqClimatempo",
        });
      } else {
        window.dataLayer.push({
          event: "close_accordion",
          id: `Accordion_FaqClimatempo_Item_Questao-0${index + 1}`,
          name: "Accordion_FaqClimatempo",
        });
      }

      item.classList.toggle("border-radius");
      button.classList.toggle("rotate");
      answer.classList.toggle("none-display");
    });
  });
};

const accordionFaq = {
  handleAnswerOpening,
};

export default accordionFaq;
